module.exports = __webpack_public_path__ + "img/5_24.a28c3c7d.png";